import {Text} from 'native-base';
import React from 'react';

export interface PRTitleProps {
  children: string | string[];
  testID: string;
}

const PRTitle: React.FC<PRTitleProps> = ({children, testID}) => {
  return (
    <Text
      fontSize="20px"
      fontWeight="bold"
      lineHeight="22px"
      fontFamily="heading"
      width="100%"
      mb={1}
      testID={testID + '-title'}
    >
      {children}
    </Text>
  );
};

export default PRTitle;
